import { Schema } from "@comparaonline/products-schema";
import React from "react";
import { Query, QueryProps } from "react-apollo";

import { useAppContext } from "../../../lib/appContext";
import { getFilters } from "../getFilters";

export type FiltersData = Pick<Schema.Query, "entityFilterList">;
type FilterArguments = Schema.EntityFilterListQueryArgs;

class BaseQuery extends Query<FiltersData, FilterArguments> {}

export type IFiltersQueryProps = Pick<QueryProps<FiltersData, FilterArguments>, "children">;

export const FiltersQuery: React.FC<IFiltersQueryProps> = ({ children }) => {
  const {
    businessUnitConfig: { businessCode: businessUnit }
  } = useAppContext();
  return (
    <BaseQuery variables={{ businessUnit }} query={getFilters}>
      {data => children(data)}
    </BaseQuery>
  );
};
